export default __webpack_public_path__ + "static/debosz_gradient-6d9e3e580fa265ef36b0bb90eb7c073f.svg";